/**
 * @file
 */


const currencyFormat = new Intl.NumberFormat('en-US', {
   style: 'currency',
   currency: 'USD',
   minimumFractionDigits: 2
})

export function InitializeIncomeChangePages() {
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   // disable sections if appropriate on doc ready
   itializeSections();

   // handle section changes if appropriate when employment status changes
   $("[id$='ddlEmploymentStatus']").change(function () {
      var selectedValue = $(this).val();

      if ((selectedValue == "Unemployed") || (selectedValue == "Not Applicable")) {
         disableSections();

      } else {
         enableSections();
      }
   });

   $("[id$='ddlAdditionalPayFrequency']").change(function () {
      var selectedValue = $(this).val();

      if (selectedValue == "N/A") {
         disableAdditionalWages();

      } else {
         enableAdditionalWages();
      }
   });



   // calculate annual income if standard or additional wages change
   $("[id$='txtStandardWages'],[id$='txtAdditionalWages']").change(function () {
      if ($(this).val() == "") { $(this).val(0.00); }

      var standardWagesStr = $("[id$='txtStandardWages']").val().replace(/[$,]/g, "");
      var standardWages = parseFloat(standardWagesStr);
      var additionalWagesStr = $("[id$='txtAdditionalWages']").val().replace(/[$,]/g, "");
      var additionalWages = parseFloat(additionalWagesStr);
      var annualIncome = ((isNaN(standardWages)) ? 0 : standardWages) + ((isNaN(additionalWages)) ? 0 : additionalWages);
      var lblannualIncome = $("[id$='lblEstimatedAnnualIncome']");
      var hdnTotalIncome = $("[id$='hdnTotalIncome']");

      lblannualIncome.text(currencyFormat.format(annualIncome));
      hdnTotalIncome.val(annualIncome);
   });
};

function itializeSections() {
   var employmentStatus = $("[id$='ddlEmploymentStatus']");
   var selectedValue = employmentStatus.val();

   if ((selectedValue == "Unemployed") || (selectedValue == "Not Applicable")) {
      disableSections();
   }

   var additionalWagesFrequency = $("[id$='ddlAdditionalPayFrequency']");
   var additionalWagesValue = additionalWagesFrequency.val();

   if (additionalWagesValue == "N/A") {
      disableAdditionalWages();
   }
}

function disableSections() {
   // disable and hide everything except employment status and begin date
   $(".employerInputSection").css("display", "none");
   $(".employerInput").prop('disabled', true).removeClass("cvg_Employer");
}

function enableSections() {
   $(".employerInputSection").css("display", "flex");
   $(".employerInput").each(function () {
      $(this).prop('disabled', false);
      if (!$(this).hasClass("cvg_Employer")) {
         $(this).addClass("cvg_Employer");
      }
   });
}

function disableAdditionalWages() {
   // disable and hide everything except employment status and begin date
   $(".additionalWages").css("display", "none");
   $(".additionalWages .employerInput").prop('disabled', true).removeClass("cvg_Employer");
   $(':input[id$="txtAdditionalWages"]').val("");
   $(':input[id$="txtAdditionalWages"]').change();
}

function enableAdditionalWages() {
   $(".additionalWages").css("display", "flex");
   $(".additionalWages .employerInput").each(function () {
      $(this).prop('disabled', false);
      if (!$(this).hasClass("cvg_Employer")) {
         $(this).addClass("cvg_Employer");
      }
   });
}
